import React, { Component } from 'react';
import Style from './index.less';
import classNames from 'classnames';
import * as ICON from './preset-icons';
import {
    ReflectionPresetStyleList,
    EffectPropsField,
    DefaultEffectPresetProps,
} from '@src/framework/editor/src/js/constants';
import { ActionType } from '@src/framework/editor/src/js/constants/common-action-type';
import i18n from '@i18next/i18n';
import * as TextIcon from '@com-pc/palette-panel/effect-preset-menu/reflection-preset-menu/preset-icons/index-text';
import ImageQuickLookManager
    from '@src/slide/infrastructure/module/dependent/image/image-toolkit/image-quick-look-manager';

const defaultReflectionProps = {
    ...DefaultEffectPresetProps[ActionType.REFLECTION],
    [EffectPropsField.STARTOPACITY.name]: 0,
    [EffectPropsField.SIZE.name]: 0,
};

const ReflectionStyleAndPropsMapping = {
    'reflection-empty-click': null,
    'reflection-empty-hover': {
        ...defaultReflectionProps,
        [EffectPropsField.STARTOPACITY.name]: 0,
        [EffectPropsField.SIZE.name]: 0,
    },
    'close-0-dy': {
        ...defaultReflectionProps,
        [EffectPropsField.STARTOPACITY.name]: 48,
        [EffectPropsField.SIZE.name]: 45,
    },
    'close-4-dy': {
        ...defaultReflectionProps,
        [EffectPropsField.STARTOPACITY.name]: 50,
        [EffectPropsField.SIZE.name]: 50,
        [EffectPropsField.DISTANCE.name]: 1,
    },
    'close-8-dy': {
        ...defaultReflectionProps,
        [EffectPropsField.STARTOPACITY.name]: 50,
        [EffectPropsField.SIZE.name]: 50,
        [EffectPropsField.DISTANCE.name]: 3,
    },
};

const TextIconMapping = {
    'close-0-dy': TextIcon.TextDrawerClose0Dy,
    'close-4-dy': TextIcon.TextDrawerClose4Dy,
    'close-8-dy': TextIcon.TextDrawerClose8Dy,
};

interface ReflectionPresetMenuProps {
    preset: { style: string };
    onReflectionPresetStyleClick: (props: any) => void;
    onReflectionPresetStyleHover?: (props: any) => void;
    onReflectionPresetStyleMouseEnter: (props: any) => void;
    onReflectionPresetStyleMouseLeave: () => void;
    containerStyle?: React.CSSProperties;
}

export default class ReflectionPresetMenu extends Component<ReflectionPresetMenuProps> {
    public static PresetIconOnShow = {
        'reflect-empty': ICON.DrawerEMPTY,
        'close-0-dy': ICON.DrawerClose0Dy,
        'close-4-dy': ICON.DrawerClose4Dy,
        'close-8-dy': ICON.DrawerClose8Dy,
    };

    private reflectionPresetDropList: { style: string, key: string, isSelected: boolean }[] = [];

    public constructor(props: ReflectionPresetMenuProps) {
        super(props);

        for (let i = 0, len = ReflectionPresetStyleList.length; i < len; i++) {
            const item = ReflectionPresetStyleList[i];
            this.reflectionPresetDropList.push({
                ...item,
                // icon: ReflectionPresetIconList[i],
                isSelected: item.style === this.props.preset.style,
            });
        }
    }

    public render() {
        return (
            <div className={Style.container}
                style={this.props.containerStyle}
            >
                <div className={Style['no-reflection-title']}
                    onClick={() => this.handleReflectionPresetIconClick('reflection-empty-click')}
                    onMouseEnter={() => this.handleReflectionPresetIconMouseEnter('reflection-empty-hover')}
                    onMouseLeave={() => this.handleReflectionPresetIconMouseLeave()}
                >
                    <span>{i18n.t('无效果')}</span>
                </div>
                <div className={Style['reflection-type-title']}>{i18n.t('映像')}</div>
                <div className={Style['reflection-collection']}>
                    {
                        this.reflectionPresetDropList.map((item) => {
                            const reflectionItemClass = classNames({
                                [Style['reflection-collection-item']]: true,
                                [Style['reflection-item-selected']]: item.isSelected,
                            });
                            return (
                                <div key={item.key}
                                    className={reflectionItemClass}
                                    onMouseEnter={() => {
                                        this.handleReflectionPresetIconMouseEnter(item.style);
                                    }}
                                    onClick={() => {
                                        this.handleReflectionPresetIconClick(item.style);
                                    }}
                                    onMouseLeave={() => {
                                        this.handleReflectionPresetIconMouseLeave();
                                    }}>
                                    {/* <img src={item.icon}></img> */}
                                    <div className={Style['reflection-item-img']}>
                                        <img
                                            src={ImageQuickLookManager
                                                .getInstance()
                                                .getDisplayUrl(TextIconMapping[item.style])}
                                            style={{
                                                width: '22px',
                                                height: 'auto',
                                            }}
                                        />
                                    </div>
                                </div>
                            );
                        })
                    }
                </div>
            </div>
        );
    }

    private handleReflectionPresetIconMouseEnter = (style: string) => {
        const value = ReflectionStyleAndPropsMapping[style];
        this.props.onReflectionPresetStyleMouseEnter(value ? { ...value } : value);
    };

    private handleReflectionPresetIconClick = (style: string) => {
        const value = ReflectionStyleAndPropsMapping[style];
        this.props.onReflectionPresetStyleClick(value ? { ...value } : value);
    };

    private handleReflectionPresetIconMouseLeave = () => {
        this.props.onReflectionPresetStyleMouseLeave();
    };
}
